import { call, put, race, select, take } from 'redux-saga/effects';
import { allFilesUploadSuccessAction, FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL, FILE_UPLOAD_SINGLE_FILE_UPLOAD_COMPLETE, singleFileUploadStartAction } from '../../actions';
import { getFirstReadyFile, isAllUploadComplete, isAllUploadSuccess, getFilesByIds, getUploadsInProgressCount } from '../../selectors';
import { DeviceUtilitiesService } from '@mitchell/react.component.ux';
const DEFAULT_MAX_PARALLEL_UPLOAD_COUNT = 3;
function getMaxParallelUploadCount(action) {
    let maxParallelUploadCount = DEFAULT_MAX_PARALLEL_UPLOAD_COUNT;
    if (action.payload.maxParallelUploadCount && action.payload.maxParallelUploadCount > 0) {
        maxParallelUploadCount = action.payload.maxParallelUploadCount;
    }
    return maxParallelUploadCount;
}
const getIdsForFiles = (files) => files.map(file => file.id);
export const uploadSaga = function* (action) {
    try {
        const maxParallelUploadCount = getMaxParallelUploadCount(action);
        while (!(yield select(isAllUploadComplete))) {
            const fileInfo = yield select(getFirstReadyFile);
            if (fileInfo && (yield select(getUploadsInProgressCount)) <= maxParallelUploadCount) {
                yield put(singleFileUploadStartAction(fileInfo.id));
            }
            else {
                yield race({
                    upload: take(FILE_UPLOAD_SINGLE_FILE_UPLOAD_COMPLETE),
                    cancel: take(FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL)
                });
            }
        }
        if (yield select(isAllUploadSuccess)) {
            const deviceUtilities = new DeviceUtilitiesService();
            const isMobile = deviceUtilities.isMobile();
            yield put(allFilesUploadSuccessAction(isMobile));
        }
    }
    finally {
        if (action.payload.onAllFileUploadComplete) {
            const files = yield select(getFilesByIds, getIdsForFiles(action.payload.files));
            yield call(action.payload.onAllFileUploadComplete, files);
        }
    }
};
//# sourceMappingURL=uploadSaga.js.map